import { Calendar } from 'primereact/calendar';
import React, { ReactNode } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { FormEvent } from 'primereact/ts-helpers';
import { Labelled, LabelledProps } from './Labelled';

interface LabelledCalendarProps extends LabelledProps {
  value: Date;
  onChange: (value: Date | null) => void;
  autoFocus?: boolean;
  className?: string;
}

const parseDate = (value: Date | null): Date | null =>
  value ? new Date(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate())) : null;

export const LabelledCalendar = (props: LabelledCalendarProps): ReactNode => {
  const intl: IntlShape = useIntl();
  const disabled: boolean = (props.permissions ? !props.permissions.canWrite : false) || props.disabled;
  return (
    <Labelled {...props}>
      <Calendar
        id={props.id}
        value={props.value}
        required={props.permissions?.required || props.required}
        invalid={props.validation && !props.validation?.valid}
        disabled={disabled}
        onChange={(event: FormEvent<(Date | null)>): void => props.onChange(parseDate(event.value))}
        dateFormat="yy-mm-dd"
        mask={'9999-99-99'}
        locale={intl.locale}
        autoFocus={props.autoFocus}
        className={props.className}
        showButtonBar={true}
        tooltip={(props.validation && !props.validation?.valid && props.validation.reason) ? props.validation.reason.split(';').map((reason: string): string => intl.formatMessage({id: reason})).join('; ') : undefined}
        tooltipOptions={{position: 'bottom'}}
      />
    </Labelled>
  );
};
